import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'pm-dashboard-btn-renderer',
  template: `
    <div style="display: flex;">
      <button
        mat-mini-fab
        color="primary"
        (click)="onClick($event)"
        tooltipPosition="top"
        pTooltip="Checklist History"
      >
        <mat-icon>list_alt</mat-icon>
      </button>
      <button
        mat-mini-fab
        color="primary"
        style="background-color:#35304e;"
        (click)="onClick($event)"
        tooltipPosition="top"
        pTooltip="Parameter History"
      >
        <mat-icon>format_list_bulleted</mat-icon>
      </button>
      <button
        style="background-color:#4CAF50;"
        title="Subtasks"
        mat-icon-button
        matTooltip="View Subtasks"
        matTooltipPosition="right"
        (click)="onClick($event)"
      >
        <i class="fa fa-tasks" style="color: white;" aria-hidden="true"></i>
      </button>

      <button
        mat-mini-fab
        color="primary"
        style="background-color:#35304e;"
        (click)="onClick($event)"
        tooltipPosition="top"
        pTooltip="View WorkLogs"
        style="background-color:#7B1FA2;"
      >
        <mat-icon style="color: white;">fact_check</mat-icon>
      </button>
    </div>
  `,
})
// tslint:disable-next-line:component-class-suffix
export class pmDasboardbtnRenderer
  implements ICellRendererAngularComp, OnDestroy
{
  params: any;
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }
  agInit(params: any): void {
    this.params = params;
  }
  onClick($event: any): any {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      console.log('this.params', this.params);
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onClick(params);
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
